export default __webpack_public_path__ + "static/media/59_Random_Right.4c14c42b.mp4";